import React, { useState } from "react";
import { useTable, useFilters, useSortBy } from "react-table";
// import moment from "moment";
import axios from "../../axios";

import Report from "../Report";
import moment from "moment-timezone";

const ReportsTable = (props) => {
  const [showReport, setShowReport] = useState([]);
  const [audioRecords, setAudioRecords] = useState({});
  

  const data = React.useMemo(() => props.records, [props.records]);
  const columns = React.useMemo(
    () => [
      {
        Header: "Date",
        id: "date",
        accessor: (row) => {
          const s = row.timestamp + "Z";
          const timezone = localStorage.timezone;

          if (timezone == "UTC") {
            return moment(row.timestamp).format("DD MMM");
          } else {
            const convertedDate = moment.tz(s, timezone).format("DD MMM");
            return convertedDate;
          }
        },
      },
      {
        Header: "Time",
        id: "time",

        accessor: (row) => {
          const s = row.timestamp + "Z";
          const timezone = localStorage.timezone;
          if (timezone == "UTC") {
            return moment(row.timestamp).format("hh:mm a");
          } else {
            const convertedDate = moment.tz(s, timezone).format("hh:mm a");
            return convertedDate;
          }
        },
      },
      {
        Header: "Assessment ID",
        id: "record",
        accessor: "recordId",
      },
      {
        Header: "Report",
        accessor: "recordId",
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setFilter,
  } = useTable(
    {
      columns,
      data,
      initialState: { sortBy: [{ id: 'date', desc: true }] },
    },
    useFilters,
    useSortBy
  );

  const onShowReport = (id, recordId, userId) => {
    setShowReport([...showReport, id]);

    let audioFormData = new FormData();
    audioFormData.append("doctorId", props.doctorId);
    audioFormData.append("recordId", recordId);
    audioFormData.append("patientId", userId);

    axios({
      method: "POST",
      url: "/getCoughAudioRecord",
      data: audioFormData,
      headers: { accessToken: localStorage.accessToken },
    })
      .then((response) => {
        setAudioRecords({ ...audioRecords, [id]: response.data.recordLink });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onCloseReport = (id) => {
    setShowReport(showReport.filter((reportId) => reportId !== id));
  };

  return (
    <div className="table" {...getTableProps()}>
      <div className="table--patients__header">
        <p className="table--patients__header__title">Reports</p>
        <p className="table--patients__header__count">
          <span>{rows.length}</span> Successful / <span> {props.errorRecordLength}</span> Invalid Assessments
        </p>
      </div>
      {headerGroups.map((headerGroup) => (
        <div
          className="table__col-header table--reports__col-header"
          {...headerGroup.getHeaderGroupProps()}
        >
          {headerGroup.headers.map((column) => (
            <div
              className="table__col-header__item"
              {...column.getHeaderProps(column.getSortByToggleProps())}
            >
              <p>{column.Header}</p>
            </div>
          ))}
        </div>
      ))}
      <div {...getTableBodyProps()}>
        {rows.map((row) => {
          // console.log(row)
          prepareRow(row);
          return (
            <div>
              <div key={row.id} className="table__row table--reports__row">
                {row.cells.map((cell) => {
                  if (cell.column.Header === "Report") {
                    return (
                      <div
                        key={cell.value + cell.row.id}
                        className="table__row__item"
                      >
                        {showReport.indexOf(cell.row.id) >= 0 ? (
                          <p
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={() => onCloseReport(cell.row.id)}
                          >
                            Close Report
                          </p>
                        ) : (
                          <p
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              onShowReport(
                                cell.row.id,
                                cell.row.original.recordId,
                                cell.row.original.patientId
                              )
                            }
                          >
                            View Report
                          </p>
                        )}
                      </div>
                    );
                  } else {
                    return (
                      <div
                        key={cell.value + cell.row.id}
                        className="table__row__item"
                      >
                        <p>{cell.value}</p>
                      </div>
                    );
                  }
                })}
              </div>
              {showReport.indexOf(row.id) >= 0 && (
                <Report
                  record={row.original}
                  recordLink={audioRecords[row.id]}
                  reportLink={props.reportLink}
                  style={{ marginTop: "2.4rem" }}
                  reload={props.reload}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ReportsTable;
